import { loadStripe } from '@stripe/stripe-js';
import api from '../api';

const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

let stripePromise = null;

export const getStripe = async () => {
  if (!stripePromise) {
    if (STRIPE_PUBLISHABLE_KEY) {
      stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
    } else {
      const { data } = await api.get('/stripe/publishable-key');
      stripePromise = loadStripe(data.publishable_key);
    }
  }
  return stripePromise;
};

export const stripeService = {
  // Mobilitier Connect
  async createConnectAccount(returnUrl, refreshUrl) {
    const response = await api.post('/stripe/connect/create', {
      return_url: returnUrl,
      refresh_url: refreshUrl
    });
    return response.data;
  },

  async getConnectStatus() {
    const response = await api.get('/stripe/connect/status');
    return response.data;
  },

  // Customer & Payment
  async createSetupIntent() {
    const response = await api.post('/stripe/setup-intent');
    return response.data;
  },

  async createPaymentIntent(bookingId) {
    const response = await api.post('/stripe/payment-intent/create', {
      booking_id: bookingId
    });
    return response.data;
  },

  async capturePayment(paymentIntentId) {
    const response = await api.post(`/stripe/payment-intent/${paymentIntentId}/capture`);
    return response.data;
  }
};
